export const formatDate = (date) => {
        
    const months = [
        "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
        "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
        ];

        const [year, month, day] = date.split("-");
        const monthAbbreviation = months[parseInt(month, 10) - 1];
        const formattedDate = `${day}-${monthAbbreviation}`;

        return formattedDate;
}